import { contractInvalidation } from './Contract/contract.contract.cacheKeys'
import { useFetchAll } from './Contract/hooks/useFetchAll'
import { useFetchOne } from './Contract/hooks/useFetchOne'
import { contractDpaeInvalidation } from './Dpae/contract.dpae.cacheKeys'
import { useBulkPostForContracts } from './Dpae/hooks/useBulkPostForContracts'
import { useFetchForContract } from './Dpae/hooks/useFetchForContract'

// TODO: merge this with the membershipService.contract to have a single contract service

class ContractService {
  contract = {
    useFetchOne,
    useFetchAll,
    invalidateOne: contractInvalidation.invalidateContract
  }

  dpae = {
    usePostBulk: useBulkPostForContracts,
    useFetchByContractId: useFetchForContract,
    invalidateOne: contractDpaeInvalidation.invalidate_dpae_contract
  }
}

export const contractService = new ContractService()
